import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select, Tooltip } from 'antd';
import { CloseOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import { 
  getFlyCheckList
} from '../../actions/publish'

const { RangePicker } = DatePicker;
const { Option } = Select;


const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
      paddingTop: "20px",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: 'flex',
      justifyContent: 'space-between'
    },
    select: {
      width: '100%'
    },
    tableContainer: {
      width: '100%',
      '& .ant-table-cell-row-hover': {
        background: '#f0fbff !important'
      },
      '& td.ant-table-column-sort': {
        background: '#f0fbff !important'
      }
    }
  };
};

class FlyCheck extends Component {
  constructor(props){
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    companyArr: [], // 申请人下拉数据
    dataSourceArr: [], // 数据来源下拉数据
    columns: [],
    data: [],
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      KeyWord: "",
      companyName: "",
      variety: "",
      province: "",
      category: "",
      content: "",
    },
    labelObj: { // 筛选项key - label对应关系
      KeyWord: '关键词',
      companyName: '被检查单位',
      variety: '品种',
      province: '省份',
      category: '检查发现问题(大方面)',
      content: '检查发现问题',
    },
    labelListObj: { },
    selectKeys: [],
    sortObj: {},
    timer: '',
    page: {
      page: 1,
      pageSize: 10
    },
    total: 0,
    scrollObj: {
      x: 1740,
      y: 600
    },
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条数据'
        // return '当前已筛选出【' + this.state.paginationObj.total + '】条，总数据量【' + this.state.paginationObj.allTotal + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    }
  };

  getTableHeight = () => {
    // 计算表格高度
    let height = window.innerHeight
    let lineHeight = document.getElementById('searchBar').offsetHeight
    this.setState({
      scrollObj: {
        x: 1740,
        y: height - lineHeight - 211
      }
    })
  }

  componentDidMount() {
    this.getTableHeight()
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })
    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          KeyWord: urlKeyword,
        },
        showKeys: ['KeyWord']
      }, () => this.initData())
    } else {
      this.initData()
    }
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        companyName: "",
        variety: "",
        province: "",
        category: "",
        content: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (key == 'PunishmentDate') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initData = () => {
    let param =  Object.assign({}, this.state.form, this.state.page)
    getFlyCheckList(param).then(res => {
      if (res && res.DataList) {
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.DataNumber
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber
        this.setState({
          data: res.DataList.map(v => {
            v.CorporateName = v.ApplicantCompanyOrApplicantProcessingCompany
            return v
          }),
          paginationObj: newPaginationObj,
          loading: false
        }, () => {
          this.getColumns()
        })
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }

  getColumns = () => {
    let classes = this.props.classes

    let columns = [
      {
        title: '序号',
        key: 'sort',
        width: 80,
        align: 'center',
        render: (text, record, index) => {
          return (this.state.page.page - 1) * this.state.page.pageSize + index + 1
        }
      },
      {
        title: '被检查单位',
        dataIndex: 'CompanyName',
        width: 260,
        key: 'companyName',
      },
      {
        title: '品种',
        dataIndex: 'Variety',
        key: 'variety',
        width: 140,
      },
      {
        title: '省份',
        dataIndex: 'Province',
        width: 100,
        key: 'province',
      },
      {
        title: '共计不符合项',
        dataIndex: 'NonConformance',
        width: 240,
        key: 'NonConformance',
      },
      {
        title: '检查发现问题(大方面)',
        dataIndex: 'Category',
        key: 'category',
        width: 200,
      },
      {
        title: '检查发现问题',
        dataIndex: 'Content',
        width: 360,
        key: 'content',
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.Content || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content}</span>
          </Tooltip>
        },
      },
      {
        title: '备注',
        dataIndex: 'Notes',
        key: 'Notes',
        width: 360,
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.Notes || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content}</span>
          </Tooltip>
        },
      },
    ]

    this.setState({
      columns: columns,
    })
  }

  handleChange = (pagination, filters, sorter) => {
    let sortKey = sorter.column ? sorter.column.title : ''
    let order = sorter.order
    let sortObj = {
      SortCriteria: order ? sortKey : '',
      SortCriteriaMode: order == 'descend' ? 'Desc' : (order == 'ascend' ? 'Asc' : '')
    }
    this.setState({
      filteredInfo: filters,
      // sortObj: sortObj,
      loading: true
    }, () => {
      this.getColumns()
      this.initData()
    });
  };

  handleSort = () => {}

  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };

  clearAll = () => {
    this.setState({
      filteredInfo: null,
      page: {
        page: 1,
        pageSize: 10
      },
      form: {},
      loading: true
    }, () => {
      this.getColumns()
      this.initData()
    });
  };



  handleReset = (clearFilters) => {
    clearFilters()
  }

  handleSearch = (key, value, confirm) => {
    let newForm = this.state.form
    if (key === 'FilingTimeOrApprovalTime') {
      if (!value) {
        newForm.Time_KS = ''
        newForm.Time_JS = ''
      } else {
        let startTime = value[0].format('YYYY-MM-DD')
        let endTime = value[1].format('YYYY-MM-DD')
        newForm.Time_KS = startTime
        newForm.Time_JS = endTime
      }
    } else {
      if (value instanceof Array && value.length > 1) {
        newForm[key] = value.join(';')
      } else {
        newForm[key] = value
      }
    }
    this.setState({
      form: newForm,
      loading: true
    }, () => this.initData())
    confirm()
  }
  

  pageChange = (page, pageSize) => {
    if (page == this.state.page.page && pageSize == this.state.page.pageSize) {
      return
    }
    this.setState({
      page: {
        page: page,
        pageSize: pageSize
      },
      loading: true
    }, () => this.initData())
  }

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.KeyWord}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'KeyWord')} 
                placeholder="请输入关键词"/>
            </div>
            <div className="form-item">
              <div className="form-label">被检查单位</div>
              <Input  value={this.state.form.companyName}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'companyName')} 
                placeholder="请输入被检查单位"/>
            </div>
            <div className="form-item">
              <div className="form-label">品种</div>
              <Input  value={this.state.form.variety}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'variety')} 
                placeholder="请输入品种"/>
            </div>
            <div className="form-item">
              <div className="form-label">省份</div>
              <Input  value={this.state.form.province}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'province')} 
                placeholder="请输入省份"/>
            </div>
            <div className="form-item">
              <div className="form-label">检查发现问题(大方面)</div>
              <Input  value={this.state.form.category}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'category')} 
                placeholder="请输入检查发现问题(大方面)"/>
            </div>
            <div className="form-item">
              <div className="form-label">检查发现问题</div>
              <Input  value={this.state.form.content}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'content')} 
                placeholder="请输入检查发现问题"/>
            </div>
          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search" id="searchBar">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">医疗器械飞行检查情况</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                scroll={this.state.scrollObj}
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                pagination={this.state.paginationObj}
                bordered
                />
              
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(FlyCheck));
